import { Module } from 'vuex'
import { RootState } from '../types'
import { actions } from './actions'
import { getters } from './getters'
import { mutations } from './mutations'
import State from './types'
import { blankCustomerMultiplier } from './constants'

export const state: State = {
  error: false,
  customerMultipliers: blankCustomerMultiplier,
}

const namespaced = true

export const multiplier: Module<State, RootState> = {
  namespaced,
  state,
  getters,
  actions,
  mutations,
}
